import React from "react";
import { SubscriptionActionFooter } from "./SubscriptionActionDialog";
import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
  alpha,
} from "@mui/material";
import { subscriptionCardSx as paperBorderSx } from "./subscriptionStyles";

export default function SubscriptionOwnershipAction({
  user,
  members,
  selectedMemberId,
  setSelectedMemberId,
  setNewOwnerLocked,
  runTransfer,
}) {
  return (
    <Stack spacing={2}>
      <Typography fontWeight={600} sx={{ mb: 1 }}>
        Transfer Ownership
        {user.organization_name && user.organization_name !== ""
          ? " of " + user.organization_name
          : ""}
      </Typography>

      <Stack spacing={2}>
        {/* 1. 从现有成员中选择新所有者 */}
        <Stack spacing={1}>
          <Typography variant='caption' color='text.secondary'>
            Select a verified member from the current subscription to become the
            new owner:
          </Typography>
          <FormControl size='small' fullWidth>
            <InputLabel id='new-owner-select-label'>New Owner</InputLabel>
            <Select
              labelId='new-owner-select-label'
              value={selectedMemberId || ""}
              label='New Owner'
              onChange={(e) => {
                setSelectedMemberId(e.target.value);
                setNewOwnerLocked(members.find((m) => m.id === e.target.value));
              }}
              disabled={!!selectedMemberId} // 选中后锁定，防止误触
            >
              {members.length > 0 ? (
                members.map((member) => (
                  <MenuItem key={member.id} value={member.id}>
                    {member.email} ({member.type})
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No members available</MenuItem>
              )}
            </Select>
          </FormControl>
        </Stack>

        {/* 2. 展示选中的用户信息 & 转移按钮 */}
        {selectedMemberId && (
          <Paper
            elevation={0}
            sx={{
              p: 2,
              ...paperBorderSx,
              bgcolor: (t) => alpha(t.palette.success.main, 0.04),
            }}
          >
            <Stack spacing={1.5}>
              {/* 通过 ID 找到对应的成员完整信息 */}
              {(() => {
                const newOwner = members.find((m) => m.id === selectedMemberId);
                if (!newOwner) return null;
                return (
                  <>
                    <Stack direction='row' alignItems='center' spacing={1}>
                      <Avatar
                        sx={{
                          width: 32,
                          height: 32,
                          fontSize: 14,
                        }}
                      >
                        {newOwner.email?.[0].toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography variant='body2' fontWeight={600}>
                          {newOwner.email}
                        </Typography>
                        <Typography variant='caption' color='text.secondary'>
                          Role: {newOwner.role} · Type: {newOwner.type}
                        </Typography>
                      </Box>
                      {/* 右上角提供一个“更改”的小按钮 */}
                      <Button
                        size='small'
                        sx={{ ml: "auto", textTransform: "none" }}
                        onClick={() => {
                          setSelectedMemberId(null);
                          setNewOwnerLocked(null);
                        }}
                      >
                        Change
                      </Button>
                    </Stack>

                    <Divider />

                    <Typography variant='caption' color='text.secondary'>
                      Assets to transfer: All admin access including billing.
                    </Typography>

                    <SubscriptionActionFooter>
                      <Button
                        variant='contained'
                        color='error'
                        onClick={() => runTransfer(newOwner)}
                        sx={{ textTransform: "none", mt: 1 }}
                      >
                        Confirm transfer
                      </Button>
                    </SubscriptionActionFooter>
                  </>
                );
              })()}
            </Stack>
          </Paper>
        )}

        {/* 初始空状态提示 */}
        {members.length === 0 && (
          <Typography variant='caption' color='error'>
            No eligible members found in this subscription to transfer
            ownership.
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
